<template>
    <div>
        <span v-if="editable || comment !== ''" @click="showComment" :class="['icon-info', 'icon', comment !== ''? 'darkGrey' : 'grey', 'chart-header-icon']" v-tooltip.right="tooltip"></span>
        <span v-if="this.resizeAllowed && this.editable" @click="resize"
              :class="['icon-resize', width === 6 ? 'darkGrey' : 'grey', 'icon', 'chart-header-icon']"></span>
        <span v-if="editable" @click="toggleVisibility"
              :class="[this.visibility === 'intern' ? 'icon-hidden' : 'icon-visible', this.visibility === 'extern'? 'darkGrey' : 'grey','icon','chart-header-icon']"></span>
    </div>
</template>

<script>
    export default {
        name: "ChartActionBar",
        props: {
            visibility: {
                type: String,
                required: true
            },
            comment: {
                type: String,
                required: true
            },
            width: {
                type: Number,
                default: 3
            },
            resizeAllowed: {
                type: Boolean,
                default: true
            }
            ,
            editable: {
                type: Boolean,
                default: false
            }
        },
        computed:{
        tooltip() {
            if(this.editable){
                return {
                    //show: false,
                    trigger:'manual',
                    content:this.comment
                }
            }else{
                return this.comment;
            }

        }
        },
        methods: {
            resize() {
                this.$emit('resize');
            },
            toggleVisibility() {
                this.$emit('toggleVisibility');
            },
            showComment() {
                if (this.editable) {
                    this.$emit('showComment');
                } else {
                    this.$emit('showCommentTooltip');
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
    .darkGrey {
        color: #27496d !important;
    }
    .pink {
        color: #d70364 !important;
    }

    .grey {
        color: #d0d4da !important;
    }

    .chart-header-icon {
        float: right;
        font-size: 2em;
        color: #eceef0;
        padding-left: 1rem;
        cursor: pointer !important;
    }

    .tooltip[x-placement^="right"] {
        margin-left: 5px;
    }

    .tooltip[x-placement^="right"] .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[x-placement^="left"] {
        margin-right: 5px;
    }

    .tooltip[x-placement^="left"] .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }


    @media (max-width: 767px) {
        .chart-header-icon {
            font-size: 1.4em;
        }
    }

</style>